import Router from './Router/Router';

function App() {
  return (
    <div>
      <Router />
    </div>
  );
}

export default App;
